module.exports = __webpack_public_path__ + "img/gayle.69ccb77b.png";